Ext.define('SA.view.ComboButton', {
    alias: 'widget.combo-button',
    extend: 'SA.view.MenuButton',

    emptyText: '',
    suppressChangeEvent: false,

    initComponent() {
        this.items = this.items || [];
        this.menu = this.menu || [];

        this.callParent();

        this.refreshItems();
        this.refreshText();
    },

    beforeMenuShow() {
        if (this.needsMenuRefresh) {
            this.needsMenuRefresh = false;
            this.refreshMenu();
        }
    },

    buildItems() {
        return this.items;
    },

    checkAutoSelectFirstValue() {
        var items = this.items,
            item = this.items[0],
            selected;

        if (this.autoSelectFirstValue && items.length) {
            selected = this.getItem();

            if (selected == null) {
                item = this.extractValue(item);

                if (item != null) {
                    this.setValue(item);
                }
            }
        }
    },

    createMenu() {
        var menu = this.callParent(arguments);

        menu.addCls('sa-combo-button-menu');

        menu.getPlugin('sa-arrow').bias = 0.2;

        return menu;
    },

    extractText(item) {
        var textField = this.textField;

        if (item != null) {
            if (this.textTpl) {
                item = Ext.XTemplate.getTpl(this, 'textTpl').apply(item);
            }
            else if (textField != null) {
                item = item[textField];
            }
        }

        return (item == null ? '' : (item + '')) || this.emptyText;
    },

    extractValue(item) {
        var valueField = this.valueField;

        if (item && valueField != null) {
            item = item[valueField];
        }

        return item;
    },

    getItem() {
        var value = this.value;

        return this.items.find(item => this.extractValue(item) === value);
    },

    getValue() {
        return this.value;
    },

    onItemCheck(item, checked) {
        if (checked) {
            this.setValue(item.value);
        }
    },

    refreshChecked() {
        var value = this.value,
            menu = this.getMenu(false);

        if (menu) {
            menu.query('> menucheckitem').forEach(item => {
                item.setChecked(item.value === value);
            });
        }
    },

    refreshItems() {
        this.setItems(this.buildItems());
    },

    refreshMenu() {
        Ext.suspendLayouts();

        var items = this.items,
            menu = this.getMenu(),
            group = this.getId() + '-radio-group';

        menu.removeAll();

        menu.add(items.map(item => {
            if (item === '-') {
                return {xtype: 'menuseparator'};
            }

            var text = this.extractText(item),
                value = this.extractValue(item);

            return {
                xtype: 'menucheckitem',
                checkHandler: this.onItemCheck,
                disabled: item && item.disabled, 
                group,
                scope: this,
                text,
                value,

                xhooks: {
                    destroy() {
                        this.getFocusEl().un('blur', this.onBlur, this);

                        this.callParent();
                    }
                }
            };
        }));

        this.refreshChecked();

        Ext.resumeLayouts(true);
    },

    refreshText() {
        this.updateText(this.getItem());
    },

    setItems(items) {
        var menu = this.getMenu(false);

        this.items = items || [];
        this.itemsStringified = JSON.stringify(this.items);

        Ext.suspendLayouts();

        this.checkAutoSelectFirstValue();

        if (menu && menu.isVisible()) {
            this.refreshMenu();
        }
        else {
            this.needsMenuRefresh = true;
        }

        this.refreshText();

        Ext.resumeLayouts(true);
    },

    setItemsAndValue(items, value, {suppressEvent = false} = {}) {
        var itemsChanged = !Ext.Array.equals(JSON.stringify(items), this.itemsStringified),
            getText = () => this.extractText(this.getItem()),
            text = getText();

        this.suppressChangeEvent = suppressEvent;

        if (itemsChanged) {
            this.setItems(items);
        }

        if (value !== this.value) {
            this.setValue(value);
        }

        if (text !== getText()) {
            this.refreshText();
        }

        this.refreshChecked();

        this.suppressChangeEvent = false;
    },

    setState({items, value}) {
        this.setItemsAndValue(items, value, {suppressEvent: true});
    },

    setValue(value) {
        var changed = this.value !== value;

        this.value = value;

        Ext.suspendLayouts();

        this.refreshChecked();
        this.refreshText();

        Ext.resumeLayouts(true);

        if (changed && !this.suppressChangeEvent) {
            Ext.callback(this.selectHandler, this.scope || this, [value]);

            this.fireEvent('change', this, value);

            queueMicrotask(() => this.fireEvent('afterchange', value));
        }

    },

    setValueUnevented(value) {
        if (this.value === value) {
            return;
        }

        this.suppressChangeEvent = true;
        this.setValue(value);
        this.suppressChangeEvent = false;
    },

    showMenu() {
        this.getMenu().minWidth = this.getWidth();

        this.callParent();
    },

    updateText(item) {
        this.setText(this.extractText(item));
    }
});